import { connect } from 'react-redux';

import { userManagementActions } from "dataflow/billingPortal/actions";

import UserGroupUpdatePresentation from './UserGroupUpdatePresentation';

function mapStateToProps(state) {
    const { 
        isUserRecordUpdatedSuccessfully,

        addUserGroup_requesting, updateUserGroup_requesting,

        userPermissions
    } = state.userManagementReducers;
    
	return {
        isUserRecordUpdatedSuccessfully,

        addUserGroup_requesting, updateUserGroup_requesting,

        userPermissions
    };
}

function mapDispatchToProps(dispatch) {
    return {
        addUserGroup: (groupNameList, userList, permissionList) => { dispatch(userManagementActions.addUserGroup(groupNameList, userList, permissionList)); },
    };
}

const UserGroupUpdate = connect(mapStateToProps, mapDispatchToProps)(UserGroupUpdatePresentation);

export default UserGroupUpdate;